export const languages = { sr: 'Srpski' };
